import { render } from "./OpenGymSlider.vue?vue&type=template&id=99636c1e&scoped=true"
import script from "./OpenGymSlider.vue?vue&type=script&lang=js"
export * from "./OpenGymSlider.vue?vue&type=script&lang=js"

import "./OpenGymSlider.vue?vue&type=style&index=0&id=99636c1e&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99636c1e"]])

export default __exports__